import React from "react";
import Chart from "react-apexcharts";
import { Row, Col } from "reactstrap";
import _ from "lodash";
import BranchWiseAttrLines from "./branchKpis/BranchWiseAttrLines";

const INCREASEPERTIME = 3;
const BranchKPIs = ({ data }) => {
	if (data && _.isEmpty(data)) return <>No data found</>;
	let brands = [];
	let posValues = [];
	let negValues = [];
	let minNum = 0;
	let maxNum = 0;
	for (let elem of data) {
		let { name, value, marketShare } = elem;
		brands.push(name);
		if (maxNum < value) maxNum = value;
		if (minNum < marketShare) minNum = marketShare;
		// if (findNum < Math.abs(value)) findNum = Math.abs(value);
		posValues.push(value);
		negValues.push(-(marketShare * INCREASEPERTIME));
	}
	brands = ["Jan'24", "Feb'24", "Mar'24", "Apr'24", "May'24", "Jun'24", "Jul'24", "Aug'24", "Sep'24", "Oct'24", "Nov'24", "Dec'24"];
	const series = [
		{
			name: "Branches",
			data: [89, 98, 92, 96, 82, 94, 95, 0, 0, 0, 0, 0],
		},
	];
	let colors = [
		"#B4C7E7",
		"#B4C7E7",
		"#B4C7E7",
		"#B4C7E7",
		"#B4C7E7",
		"#B4C7E7",
		"#00B0F0",
		"#B4C7E7",
		"#B4C7E7",
		"#B4C7E7",
		"#B4C7E7",
		"#B4C7E7",
	];
	const options = {
		chart: {
			height: 400,
			// stacked: true,
			toolbar: {
				show: false,
			},
		},
		legend: {
			show: false,
		},
		colors,
		plotOptions: {
			bar: {
				horizontal: true,
				barHeight: "100%",
				distributed: true,
			},
		},
		annotations: {
			xaxis: [
				{
					x: 0,
					borderColor: "#000",
					fillColor: "#000",
					strokeDashArray: 0,
					borderWidth: 0.5,
					label: {
						borderColor: "#000",
						style: {
							color: "#fff",
							background: "#000",
						},
						text: "",
					},
				},
			],
		},

		dataLabels: {
			enabled: true,
			formatter: function (value) {
				if (value < 0) return Math.abs(parseInt(value / INCREASEPERTIME)) + "%";
				return Math.abs(parseInt(value));
			},
		},
		stroke: {
			width: 1,
			colors: ["#fff"],
		},
		grid: {
			xaxis: {
				lines: {
					show: false,
				},
			},
			yaxis: {
				lines: {
					show: false,
				},
			},
		},

		xaxis: {
			categories: brands,
			// min: -230,
			// max: 230,
			// // max: +maxNum,
			tickAmount: 10,
			labels: {
				show: false,
				formatter: function (value, timestamp, opts) {
					if (value < 0) return Math.abs(parseInt(value / INCREASEPERTIME)) + "%";
					return Math.abs(parseInt(value));
				},
			},
			axisBorder: { show: false },
			axisTicks: {
				show: false,
				// height: 4,
				// offsetX: -1,
			},
		},
		tooltip: {
			custom: function ({ series, seriesIndex, dataPointIndex, w }) {
				let { xaxis } = w.config;
				let displayCategories = xaxis.categories[dataPointIndex];
				let value = series[seriesIndex][dataPointIndex];
				if (value < 0) value = Math.abs(parseInt(value)) + "%";
				else value = Math.abs(parseInt(value));
				return '<div class="arrow_box p-2">' + "<span>" + displayCategories + ": " + value + "</span>" + "</div>";
			},
		},
		// title: {
		// 	text: "95 % Overall Branch Score YTD'24",
		// 	align: "center",
		// },
	};
	return (
		<Row>
			<Col lg="4">
				<div>
					<span style={{ fontSize: "xx-large", fontWeight: "bold" }}>95%</span>
					<br /> Overall Call Center Score YTD'24
				</div>
				<Chart options={options} series={series} type={"bar"} height={400} />
			</Col>
			<Col lg="8">
				<BranchWiseAttrLines />
			</Col>
		</Row>
	);
};

export default BranchKPIs;
